export const REGISTRATION_ROLE_OPTIONS = [
  { value: 'pyme', label: 'Soy PYME' },
  { value: 'mentor', label: 'Soy Mentor' },
  { value: 'none', label: 'Ninguna de las anteriores' },
];

export const DEFAULT_AVAILABLE_ROLES = REGISTRATION_ROLE_OPTIONS.map(
  ({ value }) => value
);

export const normalizeAvailableRoles = (availableRoles) => {
  if (availableRoles === undefined) {
    return [...DEFAULT_AVAILABLE_ROLES];
  }

  if (!Array.isArray(availableRoles)) {
    return [];
  }

  const hasInvalidRole = availableRoles.some(
    (role) => !DEFAULT_AVAILABLE_ROLES.includes(role)
  );
  const hasDuplicates = new Set(availableRoles).size !== availableRoles.length;

  if (hasInvalidRole || hasDuplicates) {
    return [];
  }

  return DEFAULT_AVAILABLE_ROLES.filter((role) =>
    availableRoles.includes(role)
  );
};
